import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Text, YStack, getTokens } from 'tamagui';
import EventIcon from '@mui/icons-material/Event';
import { Strings } from '../../constants/Strings';
import { CobuButton } from '@cobu/ui';
import { getFloatingBottomOffset } from '../../constants/layout';
const strings = Strings.get();
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { useResidentRestrictions } from '../../hooks/useResidentRestrictions';


export function AddEventFloatingButton() {
  const navigate = useNavigate();
  const tokens = getTokens();
  const { residentsCanCreateEvents } = useFeatureFlags();
  const { canCreateEvent } = useResidentRestrictions();

  const handlePress = () => {
      navigate('/events/create-group-event');
  };

  const bottomOffset = getFloatingBottomOffset(tokens.space.$8.val);

  if (!residentsCanCreateEvents || !canCreateEvent) return null;

  return (
    <YStack
    style={{
      position: 'fixed',
      bottom: bottomOffset,
      right: '2.5%',
      zIndex: 1000,
      width: '45%',
    }}
    >
      <CobuButton
        backgroundColor="$cobuPink"
        borderRadius="$6"
        paddingHorizontal="$4"
        flexDirection="row"
        alignItems="center"
        onPress={handlePress}
        height={'$8'}
      >
        <EventIcon htmlColor='white' fontSize="small" />
        <Text
          fontSize="$3"
          fontWeight="bold"
          color="$white"
        >
          {strings.ui.floatingButton.addEvent}
        </Text>
      </CobuButton>
    </YStack>
  );
}